import { fa } from 'vuetify/iconsets/fa-svg';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import defaultTheme from '@/modules/vuetify/themes/defaultTheme';
import { VDateInput } from 'vuetify/labs/VDateInput';
import { VTimePicker } from 'vuetify/labs/VTimePicker';
import { VTreeview } from 'vuetify/labs/VTreeview';
import { VStepperVertical } from 'vuetify/labs/VStepperVertical'

import {
  mdiDeleteOutline,
  mdiPencilOutline,
  mdiMagnify,
  mdiMenuUp,
  mdiMenuDown,
  mdiChevronRight,
  mdiChevronLeft,
  mdiPlus,
  mdiAlertCircleOutline,
  mdiEyeOutline,
  mdiEyeOffOutline,
  mdiCogOutline,
  mdiLockOutline,
  mdiAccountMultipleOutline,
  mdiViewDashboardOutline,
  mdiAccountTie,
  mdiInvoiceListOutline,
  mdiStoreOutline,
  mdiListBoxOutline,
  mdiCloverOutline,
  mdiAccountOutline,
  mdiEmailOutline,
  mdiClockOutline,
  mdiPartyPopper,
  mdiCalendarRange,
  mdiExport,
  mdiClose,
  mdiFileTree,
  mdiDrag,
  mdiTrashCanOutline,
  mdiGrid,
  mdiGridLarge,
  mdiImagePlus,
  mdiFolderPlus,
  mdiFolder,
  mdiHome,
  mdiPaperclip,
  mdiUpload,
  mdiFile,
  mdiCrop,
  mdiMonitor,
  mdiTablet,
  mdiCellphone,
  mdiRefresh,
  mdiShareVariantOutline,
  mdiUndo,
  mdiRedo,
  mdiFileWord,
  mdiFileExcel,
  mdiFilePdfBox,
  mdiFileDocument, //default
  mdiPostOutline,
  mdiCodeJson,
  mdiResize,
  mdiWidgetsOutline,
  mdiUnfoldLessHorizontal,
  mdiUnfoldMoreHorizontal,
  mdiContentSaveOutline,
  mdiContentDuplicate,
  mdiLink, mdiViewList, mdiCheck
} from '@mdi/js';
import { createVuetify } from 'vuetify';

export const install = (app: any) => {
    const vuetify = createVuetify({
        icons: {
            defaultSet: 'mdi',
            aliases: {
                ...aliases,
                'delete': mdiDeleteOutline,
                'edit': mdiPencilOutline,
                'search': mdiMagnify,
                'up': mdiMenuUp,
                'down': mdiMenuDown,
                'right': mdiChevronRight,
                'left': mdiChevronLeft,
                'add': mdiPlus,
                'alert' : mdiAlertCircleOutline,
                'show': mdiEyeOutline,
                'hide': mdiEyeOffOutline,
                'settings': mdiCogOutline,
                'lock': mdiLockOutline,
                'users': mdiAccountMultipleOutline,
                'dashboard': mdiViewDashboardOutline,
                'admin': mdiAccountTie,
                'invoices': mdiInvoiceListOutline,
                'store': mdiStoreOutline,
                'list': mdiListBoxOutline,
                'clover': mdiCloverOutline,
                'user': mdiAccountOutline,
                'email': mdiEmailOutline,
                'clock': mdiClockOutline,
                'calendar': mdiCalendarRange,
                'party': mdiPartyPopper,
                'export': mdiExport,
                'file-tree': mdiFileTree,
                'close': mdiClose,
                'drag': mdiDrag,
                'trash': mdiTrashCanOutline,
                'grid': mdiGrid,
                'grid-large': mdiGridLarge,
                'plus': mdiPlus,
                'image-plus': mdiImagePlus,
                'folder-plus': mdiFolderPlus,
                'folder': mdiFolder,
                'home': mdiHome,
                'paperclip': mdiPaperclip,
                'upload': mdiUpload,
                'file': mdiFile,
                'crop': mdiCrop,
                'desktop': mdiMonitor,
                'table': mdiTablet,
                'mobile': mdiCellphone,
                'refresh': mdiRefresh,
                'share-variant': mdiShareVariantOutline,
                'undo': mdiUndo,
                'redo': mdiRedo,
                'excel': mdiFileExcel,
                'word': mdiFileWord,
                'pdf': mdiFilePdfBox,
                'file-document': mdiFileDocument, //default,
                'post': mdiPostOutline,
                'code-json': mdiCodeJson,
                'magnify' :mdiMagnify,
                'resize' :mdiResize,
                'widgets':mdiWidgetsOutline,
                'unfold-less-horizontal': mdiUnfoldLessHorizontal,
                'unfold-more-horizontal': mdiUnfoldMoreHorizontal,
                'save': mdiContentSaveOutline,
                'duplicate': mdiContentDuplicate,
                'link': mdiLink,
                'view-list': mdiViewList,
                'cog': mdiCogOutline,
                'check': mdiCheck
            },
            sets: { fa, mdi },
        },
        theme: {
            defaultTheme: 'dark',
            themes: {
                defaultTheme,
                dark: {}
            }
        }
    });

    app.component('v-date-input', VDateInput);
    app.component('v-time-picker', VTimePicker);
    app.component('v-treeview', VTreeview);
    app.component( VStepperVertical);

  app.use(vuetify);
};
